export default "__VITE_ASSET__3fa2540f__"